import React, { useState, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "../../style/AddEventModal.css";

const AddEventModal = ({ isOpen, onClose, onAddEvent, tags }) => {
  if (!isOpen) return null;

  // Use refs instead of useState
  const titleRef = useRef();
  const dateRef = useRef();
  const timeRef = useRef();
  const locationRef = useRef();
  const descriptionRef = useRef();
  const tagNameRef = useRef();
  const tagColorRef = useRef();
  const tagIdRef = useRef();

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent page reload

    const title = titleRef.current.value.trim();
    const event_date = dateRef.current.value;
    const event_time = timeRef.current.value;
    const location = locationRef.current.value.trim();
    const description = descriptionRef.current.value.trim();
    const tag_id = tagIdRef.current?.value || null;


    // Validate title length before submitting
    if (title.length < 3 || title.length > 255) {
      alert("Title must be between 3 and 255 characters.");
      return;
    }

    // Pass event data to parent component
    onAddEvent({ title, event_date, event_time, location, description, tag_id });

    onClose(); // Close modal after submission
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>New Event</h2>
          <CloseIcon className="close-icon" onClick={onClose} />
        </div>
        <form onSubmit={handleSubmit} className="modal-form">
          <input
            type="text"
            ref={titleRef}
            placeholder="Title"
            className="modal-input"
            required
          />

          <div className="cal-category-selection">
            {tags.length > 0 && (
              <select ref={tagIdRef} className="modal-input">
                <option value="">Select Category (optional)</option>
                {tags.map((tag) => (
                  <option key={tag.id} value={tag.id}>
                    {tag.tag_name}
                  </option>
                ))}
              </select>
            )}
          </div>

          <div className="modal-date-time">
            <input type="date" ref={dateRef} className="modal-input" required />
            <input type="time" ref={timeRef} className="modal-input" required />
          </div>

          <input
            type="text"
            ref={locationRef}
            placeholder="Location"
            className="modal-input"
          />

          <textarea
            ref={descriptionRef}
            placeholder="Description"
            className="modal-textarea"
          ></textarea>

          <button type="submit" className="modal-button">
            Add Event
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddEventModal;